<div class="logo-container" [class.default]="startPage" (click)="goToHome()">
  <img src="../../assets/images/portal_logo.png">
</div>